import { RenderAlert } from './Render-alert';
type Props = {
  isOpen?: boolean;
  text: string;
};
export const Alert = ({
  isOpen = false,
  text
}: Props) => {
  return <RenderAlert isOpen={isOpen} text={text} data-sentry-element="RenderAlert" data-sentry-component="Alert" data-sentry-source-file="Alert.tsx" />;
};